import { SEO } from "../components/SEO";

const TermsConditions = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <SEO title="Terms & Conditions" description="Terms and conditions for Fit Print Bros custom printing services." path="/terms" />
      <div className="prose prose-lg max-w-none">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms & Conditions</h1>
        
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
          <p className="text-blue-800 mb-2"><strong>Effective Date:</strong> January 1, 2024</p>
          <p className="text-blue-700">
            Welcome to Fit Print Bros. By using our services, you agree to these terms and conditions.
          </p>
        </div>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Services</h2>
          <p className="text-gray-700 mb-4">
            Fit Print Bros provides professional printing services including screen printing, DTF printing, 
            embroidery, stickers, and large format printing. We also offer design services and artwork enhancement.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Orders & Payment</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>All orders require full payment before production begins</li>
            <li>Prices are subject to change based on artwork complexity and specifications</li>
            <li>Art fees ($25) apply for artwork that requires enhancement or vectorization</li>
            <li>Minimum quantities apply to certain products as specified</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Artwork & Intellectual Property</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>You must own or have rights to use all submitted artwork</li>
            <li>We are not responsible for copyright infringement claims</li>
            <li>We reserve the right to refuse orders that may infringe on copyrights</li>
            <li>Artwork files remain your property; we may retain copies for reorder purposes</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Production & Delivery</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>Production times vary by product and quantity</li>
            <li>Rush orders may incur additional fees</li>
            <li>We are not responsible for delays due to artwork issues or customer changes</li>
            <li>Shipping costs are additional and calculated at checkout</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Quality & Returns</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>We guarantee the quality of our printing and embroidery work</li>
            <li>Defective items will be reprinted at no charge</li>
            <li>Custom printed items cannot be returned unless defective</li>
            <li>Claims must be made within 7 days of delivery</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Limitation of Liability</h2>
          <p className="text-gray-700 mb-4">
            Our liability is limited to the cost of the order. We are not responsible for 
            consequential damages, lost profits, or other indirect damages.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Contact Information</h2>
          <p className="text-gray-700">
            For questions about these terms, please contact us through our website or call our customer service team.
          </p>
        </section>
      </div>
    </div>
  );
};

// Privacy Policy Page

export { TermsConditions };
export default TermsConditions;
